import React from 'react'

export const EricNur = () => {
  return (
    <div className='flex items-center justify-center'>COMING SOON...</div>
  )
}
